// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2i0E9","bigColWidth":"Table_bigColWidth__2PcQS","biggerColWidth":"Table_biggerColWidth__2OX8d","row":"Table_row__1xa8u","col":"Table_col__CM9h_"};